import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";

const STORAGE_KEY = "goldenelia_wishlist_v1";

const WishlistCtx = createContext(null);

const loadInitial = () => {
  try {
    const raw = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState(loadInitial());

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch { /* ignore */ }
  }, [items]);

  const toggle = useCallback((item) => {
    setItems((prev) => {
      const idx = prev.findIndex((p) => p.id === item.id);
      if (idx >= 0) return prev.filter((p) => p.id !== item.id);
      return [...prev, item];
    });
  }, []);

  const remove = useCallback((id) => {
    setItems((prev) => prev.filter((p) => p.id !== id));
  }, []);

  const has = useCallback((id) => items.some((p) => p.id === id), [items]);

  const count = useMemo(() => items.length, [items]);

  return (
    <WishlistCtx.Provider value={{ items, toggle, remove, has, count }}>
      {children}
    </WishlistCtx.Provider>
  );
};

export const useWishlist = () => {
  const ctx = useContext(WishlistCtx);
  if (!ctx) throw new Error("useWishlist must be used within WishlistProvider");
  return ctx;
};
